function _(l, t, n) {
  t.split && (t = t.split("."));
  for (var p = 0, r = t.length, i = l, f, o; p < r && (o = "" + t[p++], !(o === "__proto__" || o === "constructor" || o === "prototype")); )
    i = i[o] = p === r ? n : typeof (f = i[o]) == typeof t ? f : t[p] * 0 !== 0 || ~("" + t[p]).indexOf(".") ? {} : [];
}
export {
  _ as dset
};
//# sourceMappingURL=index45.js.map
